import {
    Integration,
    integrations
} from './lib/config';
import {
    Input
} from 'shared/components/ui/input';
import {
    Search
} from 'lucide-react';
import {
    IntegrationCard
} from './integration-card';
import {
    Card,
    CardContent,
    CardHeader
} from 'shared/components/ui/card';
import {
    useState
} from 'react';

export default function IntegrationsPage() {
    const [searchQuery, setSearchQuery] = useState<string>('');

    const filterIntegration = (item: Integration) => {
        return (item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.type && item.type.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    };

    return (
        <div className="flex p-8 overflow-y-scroll w-full min-w-[700px]">
            <div className='w-full'>
                <Card>
                    <CardHeader>
                        {/* Search Bar */}
                        <div className="mb-8 w-full bg-white">
                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
                                <Input type="search" placeholder="Search integrations name or type" className="pl-10" onChange={(e) => setSearchQuery(e.target.value)} />
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent>
                        {/* Integrations Section */}
                        <div>
                            <div className="mb-4">
                                <h2 className="text-lg font-medium text-foreground">Available Integrations</h2>
                                <p className="text-sm text-muted-foreground">Connect powerful services to enhance your application</p>
                            </div>

                            {/* Integrations Grid */}
                            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                {integrations.filter(filterIntegration).map((integration) => (
                                    <IntegrationCard key={integration.id} integration={integration} />
                                ))}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
